import { StoreType } from '@tock/shared/utils/connect';
import { createSelector } from 'reselect';

/*
  Priority tags are defined as tags that have an icon value
*/
export default createSelector(
  (state: StoreType) => state.tags.configuredTags,
  (configuredTags) => (configuredTags ? configuredTags.filter((tag) => tag.icon) : [])
);
